// src/data/contactCheck.js
//
// Bob 2026-10-14, the walk-through: a claim was filed for a member with the e-mail "gkeeley86@gmail.com." (a trailing
// period) and the phone "8y7768976t213". The e-mail matched no account, so the claim silently failed to link to the
// member (claimantNotices.linkDecision compares e-mails exactly - correctly). An address is stored cleaned: spaces and
// trailing dots or commas removed - never rewritten otherwise, never guessed. A phone with letters in it is refused with
// a plain message rather than stored. PURE; proved by scripts\test-contact-check.mjs.

// The e-mail as it will be stored: trimmed, trailing punctuation removed. Case is kept (the comparisons lower it).
export function cleanEmail(v) {
  return String(v == null ? '' : v).trim().replace(/[\s.,;:]+$/g, '').replace(/^[\s<]+|[\s>]+$/g, '');
}

// null when the e-mail is usable (or empty - an e-mail is not required everywhere); otherwise the reason, in plain words.
export function emailProblem(v) {
  const e = cleanEmail(v);
  if (!e) return null;
  if (/\s/.test(e)) return 'The e-mail address has a space in it.';
  if (!/^[^@]+@[^@]+\.[A-Za-z]{2,}$/.test(e)) return 'The e-mail address is not complete (it should look like name@example.com).';
  return null;
}

// null when the phone is usable (or empty); otherwise the reason. Digits, spaces and ( ) + - . x / ext are allowed.
export function phoneProblem(v) {
  const p = String(v == null ? '' : v).trim();
  if (!p) return null;
  if (/[^0-9\s()+\-.x/]|(?:x.*x)/i.test(p.replace(/\bext\.?/i, 'x'))) return 'The phone number has letters or symbols in it - use digits only.';
  const digits = p.replace(/\D/g, '');
  if (digits.length < 7 || digits.length > 15) return 'The phone number should have 7 to 15 digits.';
  return null;
}
